"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=assert;function assert(condition,message){if(!condition)throw new Error("Assertion failed. "+message)}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/lib/utils/assert.js
// module id = 1568
// module chunks = 0